import React, { useState, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { push } from "react-router-redux";
import { history } from "../store";
import { FileCheck, CreditCard, Timer, PenLine, X } from "lucide-react";
import { withNamespaces } from "react-i18next";

import AppHeader from "../containers/AppHeader";
import { postRedsys, postRedsysInsite, postCancelPrebooking, postGpPayment } from "../actions/qrs";
import { fetchCustomer } from "../actions/qrs";
import NmStepBar from "../components/NmStepBar";
import { currencySymbol } from '../utils/currency';

// Addon Payments (Comercia Global Payments): the HPP posts its result here;
// the endpoint validates it server-side and bounces back to TicketView.
const GP_RESPONSE_URL = "https://lockers-qr-api.vacway.es/v1/qrs/gp-response";

class PaymentView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      redsys: null,
      iva: 21,
      redsysSignature: null,
      redsysMerchant: null,
      redsysVersion: null,
      total: null,
      importeBase: null,
      importeIva: null,
      minutes: 5,
      seconds: 0,
      isTimeUp: false,
      newLockerPrice: 0,
      discountApplied: false,
      timeStamp: null,
      startDate: new Date(),
      endDate: new Date(),
      // Redsys Insite state
      paymentId: null,
      redsysURLOK: null,
      merchantCredentials: null,
      insiteScriptLoaded: false,
      insiteFormInitialized: false,
      insiteProcessing: false,
      insiteError: null,
      // Addon Payments (HPP) state
      gpJson: null,
      gpUrl: null,
      gpScriptLoaded: false,
      gpInitialized: false,
      gpError: null,
      showExitDialog: false,
      showEditConfirm: false,
      pendingNavigation: null,
    };

    this.toggle = this.toggle.bind(this);
    this.getLockerType = this.getLockerType.bind(this);
  }

  componentDidMount() {
    const {
      zoneSelected,
      descriptionZone,
      selectedAccessibility,
      selectedLocker,
      lockerPrice,
      lockerAssigned,
      lockerPin,
      lockerMatricula,
      lockerCustomer,
      lockerCustomerID,
      qr,
      timeStamp,
      qrType,
      qrMode,
      mail,
      phoneNumber,
      newsletterAcceptance,
      confirmReservation,
      idNumber,
    } = this.props.location.state;

    const { t, i18n } = this.props;

    //Idiomas Redsys - Castellano-001, Inglés-002, Catalán-003, Francés-004, Alemán-005, Holandés-006, Italiano-007, Sueco-008, Portugués-009, Valenciano-010, Polaco-011, Gallego-012 y Euskera-013.
    console.log("Language: " + i18n.language);

    let language = "001";

    switch (i18n.language) {
      case "es":
        language = "001";
        break;
      case "en":
        language = "002";
        break;
      case "it":
        language = "007";
        break;
      case "gr":
        language = "005";
        break;
      case "fr":
        language = "004";
        break;
      case "pt":
        language = "009";
        break;
    }

    //Discount temporary

    let newLockerPrice = lockerPrice;

    let discountApplied = false;

    {
      /*
    // Ensure lockerPrice is based on 5-day rate if totalDays > 5
    if (totalDays > 5) {
      const dailyRate = lockerPrice / totalDays; // Calculate the daily rate based on 5-day price
      newLockerPrice = dailyRate * 5; // Reduce the price for the excess days
      discountApplied = true;
    }
    */
    }

    // Update the state with discount status and adjusted locker price
    this.setState({ newLockerPrice, discountApplied });

    this.setState({ timeStamp: timeStamp }, () => {
      this.startCountdown();
    });

    let paymentDate = new Date().toISOString();

    let redsysPetition = {};

    const { useRedsysInsite, paymentProvider } = this.props.location.state;
    const isAddon = (paymentProvider || 'redsys') === 'addon';

    // Normalize to Redsys order format (4-12 chars) immediately so the same value
    // is used in the signed DS_MERCHANT_ORDER and in getInSiteFormJSON's `order`.
    // Addon Payments instead requires a globally unique ORDER_ID per attempt.
    let paymentId = isAddon
      ? `GP${Date.now()}${Math.floor(Math.random() * 900 + 100)}`
      : Math.floor(Math.random() * 1000000 + 1).toString().padStart(4, '0').substring(0, 12);

    let redsysURLOK = `https://lockers-qr.vacway.es/TicketView?zoneSelected=${zoneSelected}&descriptionZone=${descriptionZone}&selectedAccessibility=${selectedAccessibility}&selectedLocker=${selectedLocker}&lockerPrice=${lockerPrice}&lockerAssigned=${lockerAssigned}&lockerPin=${lockerPin}&lockerMatricula=${lockerMatricula}&lockerCustomer=${lockerCustomer}&customerId=${lockerCustomerID}&qrToken=${qr}&qrType=${qrType}&qrMode=${qrMode}&mail=${mail}&phoneNumber=${phoneNumber}&newsletterAcceptance=${newsletterAcceptance}&confirmReservation=${confirmReservation}&idNumber=${idNumber || ''}&language=${
      i18n.language
    }&paymentId=${paymentId}&paymentDate=${encodeURIComponent(paymentDate)}`;
    let redsysURLKO = `https://lockers-qr.vacway.es/PaymentError?qr=${qr}&language=${i18n.language}`;

    redsysPetition.price = lockerPrice;
    redsysPetition.redsysURLOK = redsysURLOK;
    redsysPetition.redsysURLKO = redsysURLKO;
    redsysPetition.paymentId = paymentId;

    redsysPetition.merchantCode = "351639505";
    redsysPetition.currency = "978";
    redsysPetition.terminal = "1";
    redsysPetition.merchantUrl = "https://vacway.com";
    redsysPetition.secretKey = "xhI+J4wrx0JKkeGqJ12j2+ErLNH9OpHM";
    redsysPetition.language = language;

    // Load the provider's payment script early so it's ready when params arrive
    if (useRedsysInsite && !isAddon) {
      this.loadInsiteScript(qrType);
    }
    if (isAddon && useRedsysInsite && qrType !== "free") {
      this.loadGpScript();
    }

    // Block back navigation and tab close while a locker is pre-booked
    // Skip if payment was already completed (user navigated back from TicketView)
    const paymentDoneKey = `vacway_qr_payment_done_${lockerAssigned}`;
    const paymentAlreadyDone = !!sessionStorage.getItem(paymentDoneKey);

    if (!paymentAlreadyDone) {
      this.unblockHistory = history.block((location, action) => {
        this.setState({ showExitDialog: true, pendingNavigation: { location, action } });
        return false;
      });
      window.addEventListener('beforeunload', this.handleBeforeUnload);
    }

    if (isAddon) {
      // ── Addon Payments (HPP) ────────────────────────────────────────────────
      // Credentials are resolved server-side (Customer.AddonPayments): the
      // browser only sends amount + identifiers and receives the signed JSON.
      this.setState({ paymentId, redsysURLOK });

      if (qrType === "free") {
        this.TotalComponent();
        this.setState({ redsys: { free: true } });
        return;
      }

      this.props
        .postGpPayment({
          customerId: lockerCustomerID,
          price: lockerPrice,
          paymentId,
          urlOk: redsysURLOK,
          urlKo: redsysURLKO,
          isTest: qrType === "test",
          // HPP_LANG takes ISO codes; the app's own code for German is 'gr'
          language: i18n.language === "gr" ? "de" : i18n.language,
          customerEmail: mail,
          customerPhone: phoneNumber ? `+${phoneNumber}` : undefined,
        })
        .then((answer) => {
          const gp = answer && answer.response;
          if (!gp || gp.error || !gp.hppJson) {
            console.error("[GP] payment init failed:", gp);
            this.TotalComponent();
            this.setState({ gpError: (gp && gp.error) || "No se pudo iniciar el pago" });
            return;
          }
          this.TotalComponent();
          this.setState({ redsys: gp, gpJson: gp.hppJson, gpUrl: gp.hppUrl });
        })
        .catch((error) => {
          console.error("[GP] payment init error:", error);
          this.TotalComponent();
          this.setState({ gpError: "No se pudo iniciar el pago" });
        });
      return;
    }

    this.props
      .fetchCustomer(lockerCustomerID)
      .then((customer) => {
        console.log("Customer: ", customer.response);
        console.log("Redsys: ", customer.response.Redsys);

        redsysPetition.merchantCode = customer.response.Redsys.MERCHANTCODE;
        redsysPetition.currency = customer.response.Redsys.CURRENCY;
        redsysPetition.terminal = customer.response.Redsys.TERMINAL;
        redsysPetition.merchantUrl = customer.response.Redsys.MERCHANTURL;
        redsysPetition.secretKey = customer.response.Redsys.SECRETKEY;

        console.log("redsysPetition: ", redsysPetition);

        this.props
          .postRedsys(redsysPetition)
          .then((answer) => {
            let answerRedsys = answer.response;

            let redsysSignature = answerRedsys.Ds_Signature;
            let redsysMerchant = answerRedsys.Ds_MerchantParameters;
            let redsysVersion = answerRedsys.Ds_SignatureVersion;

            this.TotalComponent();

            this.setState({
              redsys: answerRedsys,
              redsysSignature: redsysSignature,
              redsysMerchant: redsysMerchant,
              redsysVersion: redsysVersion,
              paymentId: paymentId,
              redsysURLOK: redsysURLOK,
              merchantCredentials: {
                secretKey: redsysPetition.secretKey,
                merchantCode: redsysPetition.merchantCode,
                currency: redsysPetition.currency,
                terminal: redsysPetition.terminal,
                merchantUrl: redsysPetition.merchantUrl,
              },
            });
          })
          .catch((error) => {
            console.error(error);
          });
      })
      .catch((error) => {
        console.error(error);
      });
  }

  componentDidUpdate(prevProps, prevState) {
    const { useRedsysInsite, paymentProvider } = this.props.location.state;

    if ((paymentProvider || "redsys") === "addon") {
      const { gpScriptLoaded, gpJson, gpUrl } = this.state;
      if (useRedsysInsite && !this._gpInitStarted && gpScriptLoaded && gpJson && gpUrl) {
        this._gpInitStarted = true;
        this.initGpEmbedded();
      }
      return;
    }

    const { insiteScriptLoaded, merchantCredentials, paymentId } = this.state;
    if (
      useRedsysInsite &&
      !this._insiteInitStarted &&
      insiteScriptLoaded &&
      merchantCredentials &&
      paymentId
    ) {
      this._insiteInitStarted = true;
      this.initInsiteForm();
    }
  }

  componentWillUnmount() {
    const { qr, lockerAssigned } = this.props.location.state;

    clearInterval(this.countdownInterval);
    if (this.unblockHistory) this.unblockHistory();
    window.removeEventListener('beforeunload', this.handleBeforeUnload);

    // Remove Insite script tag, message listener, and viewport listener if loaded
    const script = document.getElementById('redsys-insite-script');
    if (script) script.remove();
    const gpScript = document.getElementById('gp-hpp-script');
    if (gpScript) gpScript.remove();
    if (this._gpMessageHandler) {
      window.removeEventListener('message', this._gpMessageHandler);
      this._gpMessageHandler = null;
    }
    if (this._insiteMessageHandler) {
      window.removeEventListener('message', this._insiteMessageHandler);
    }
    if (this._viewportMediaQuery && this._viewportChangeHandler) {
      this._viewportMediaQuery.removeEventListener('change', this._viewportChangeHandler);
    }
    // Clean up any 3DS iframes/listeners still in flight
    this._cleanup3DS();

    if (!this._skipUnmountRedirect) {
      history.push(`/qrsale/${qr}?lockerAssigned=${lockerAssigned}`);
    }
  }

  handleBeforeUnload = (e) => {
    e.preventDefault();
    e.returnValue = '';
  }

  cancelPrebookingAndLeave = () => {
    const { lockerAssigned, lockerMatrixId, qr } = this.props.location.state;
    // Safety check: if payment already completed, just navigate away without cancelling
    const paymentAlreadyDone = !!sessionStorage.getItem(`vacway_qr_payment_done_${lockerAssigned}`);
    if (this.unblockHistory) this.unblockHistory();
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    clearInterval(this.countdownInterval);
    const doNavigate = () => {
      const { pendingNavigation } = this.state;
      if (pendingNavigation) {
        history.push(pendingNavigation.location);
      } else {
        history.push(`/qrsale/${qr}`);
      }
    };
    if (paymentAlreadyDone) {
      doNavigate();
      return;
    }
    this.props.postCancelPrebooking({ LockerAssigned: lockerAssigned, LockerMatrixId: lockerMatrixId })
      .finally(doNavigate);
  }

  stayOnPage = () => {
    this.setState({ showExitDialog: false, pendingNavigation: null });
  }

  goToPhoneView = () => {
    this._skipUnmountRedirect = true;
    if (this.unblockHistory) this.unblockHistory();
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    clearInterval(this.countdownInterval);
    const s = this.props.location.state;
    this.props.push('/PhoneView', {
      zoneSelected: s.zoneSelected,
      descriptionZone: s.descriptionZone,
      selectedAccessibility: s.selectedAccessibility,
      selectedLocker: s.selectedLocker,
      lockerPrice: s.lockerPrice,
      lockerAssigned: s.lockerAssigned,
      lockerPin: s.lockerPin,
      lockerMatricula: s.lockerMatricula,
      lockerCustomer: s.lockerCustomer,
      lockerCustomerID: s.lockerCustomerID,
      lockerMatrixId: s.lockerMatrixId,
      qr: s.qr,
      timeStamp: s.timeStamp,
      qrType: s.qrType,
      qrMode: s.qrMode,
      mail: s.mail,
      phoneNumber: s.phoneNumber,
      idNumber: s.idNumber,
      confirmReservation: s.confirmReservation,
    });
  }

  handleRedsysRedirect = () => {
    const { lockerAssigned } = this.props.location.state;
    // Mark payment as in-flight so timer expiry won't cancel the pre-booking
    this._paymentSubmitted = true;
    this._skipUnmountRedirect = true;
    sessionStorage.setItem(`vacway_qr_payment_done_${lockerAssigned}`, '1');
    if (this.unblockHistory) this.unblockHistory();
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  }

  loadInsiteScript(qrType) {
    if (document.getElementById('redsys-insite-script')) {
      this.setState({ insiteScriptLoaded: true });
      return;
    }
    const scriptUrl = qrType === 'test'
      ? 'https://sis-t.redsys.es:25443/sis/NC/redsysV3.js'
      : 'https://sis.redsys.es/sis/NC/redsysV3.js';
    const script = document.createElement('script');
    script.id = 'redsys-insite-script';
    script.src = scriptUrl;
    script.onload = () => this.setState({ insiteScriptLoaded: true });
    script.onerror = () => this.setState({ insiteError: 'Error al cargar el formulario de pago' });
    document.head.appendChild(script);
  }

  // ─── Addon Payments (HPP) ────────────────────────────────────────────────

  loadGpScript() {
    if (document.getElementById('gp-hpp-script') || window.RealexHpp) {
      this.setState({ gpScriptLoaded: true });
      return;
    }
    const script = document.createElement('script');
    script.id = 'gp-hpp-script';
    script.src = '/lib/rxp-js.js';
    script.onload = () => this.setState({ gpScriptLoaded: true });
    script.onerror = () => this.setState({ gpError: 'Error al cargar el formulario de pago' });
    document.head.appendChild(script);
  }

  initGpEmbedded() {
    const { gpJson, gpUrl } = this.state;
    if (!document.getElementById('gp-pay-button') || !document.getElementById('gp-hpp-frame') || !window.RealexHpp) {
      this.setState({ gpError: 'Error al inicializar el formulario de pago' });
      return;
    }
    try {
      // Listen for the HPP result BEFORE rxp-js registers its own handler, so
      // the navigation guards are released before its top-level response POST —
      // the customer must not get a "leave site?" prompt mid-payment. Resize
      // events (data with an `iframe` key) mean the form is still open.
      this._gpMessageHandler = (ev) => {
        const origin = ev.origin || '';
        if (origin.indexOf('addonpayments.com') === -1 && origin.indexOf('realexpayments.com') === -1) return;
        let parsed = null;
        try { parsed = JSON.parse(ev.data); } catch (e) { return; }
        if (parsed && parsed.iframe) return;
        // Payment finished — rxp-js will POST the result to gp-response next.
        const { lockerAssigned } = this.props.location.state;
        this._paymentSubmitted = true;
        sessionStorage.setItem(`vacway_qr_payment_done_${lockerAssigned}`, '1');
        if (this.unblockHistory) this.unblockHistory();
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
      };
      window.addEventListener('message', this._gpMessageHandler);

      window.RealexHpp.setHppUrl(gpUrl);
      // Embedded mode (validated on real mobiles 2026-09-01): the HPP renders
      // inside our own iframe — no new tab, unlike lightbox, which degrades to
      // a separate window on mobile. When the payment finishes, rxp-js POSTs
      // the hppResponse to GP_RESPONSE_URL at top level. 3DS2 (frictionless or
      // challenge) happens inside the iframe.
      window.RealexHpp.embedded.init('gp-pay-button', 'gp-hpp-frame', GP_RESPONSE_URL, gpJson);
      this.setState({ gpInitialized: true });
      // Open the HPP form right away: the hidden trigger button is only
      // rxp-js's attach point — the customer's single action is the form
      // itself inside the iframe.
      setTimeout(() => {
        const btn = document.getElementById('gp-pay-button');
        if (btn) btn.click();
      }, 0);
    } catch (err) {
      console.error('[GP] embedded init error:', err);
      this.setState({ gpError: 'Error al inicializar el formulario de pago' });
    }
  }

  gpPaymentForm(containerId) {
    const { redsys, gpJson, gpUrl, gpInitialized, gpError, redsysURLOK } = this.state;
    const { qrType, useRedsysInsite } = this.props.location.state;
    const { t } = this.props;

    // 'free' QRs skip the gateway entirely (same behaviour as the Redsys path)
    if (qrType === 'free' && redsys && redsys.free) {
      return (
        <button
          type="button"
          className="nm-btn-continue"
          onClick={() => {
            if (this.unblockHistory) this.unblockHistory();
            window.removeEventListener('beforeunload', this.handleBeforeUnload);
            window.location.href = redsysURLOK;
          }}
        >
          {t("Reservar")}
        </button>
      );
    }

    if (gpError) {
      return (
        <div className="alert alert-danger mt-2" style={{ fontSize: '13px' }}>{gpError}</div>
      );
    }

    if (!gpJson || !gpUrl) {
      return <div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>;
    }

    // The pay button/form exists once (duplicate ids across the sm/pc layouts):
    // render it only in the layout matching the current viewport.
    const activeContainerId = window.matchMedia('(min-width: 1200px)').matches
      ? 'redsys-container-pc'
      : 'redsys-container-sm';
    if (containerId !== activeContainerId) {
      return <div className="redsys-insite-wrapper" />;
    }

    if (useRedsysInsite) {
      // In-site mode: the HPP form opens automatically inside this iframe.
      // The hidden button is only rxp-js's attach point (auto-clicked on init).
      return (
        <div className="redsys-insite-wrapper">
          {!gpInitialized && (
            <div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>
          )}
          <button type="button" id="gp-pay-button" style={{ display: 'none' }} />
          {/* rxp-js posts the HPP form into this iframe and unhides it */}
          <iframe
            id="gp-hpp-frame"
            title="Pago seguro"
            style={{
              display: 'none',
              width: '100%',
              height: '640px',
              border: '1px solid rgba(10,29,61,0.15)',
              borderRadius: '12px',
              marginTop: '12px',
              background: '#ffffff',
            }}
          />
        </div>
      );
    }

    // Redirect mode: classic signed form POST to the HPP (Cyberpac-style)
    return (
      <form
        action={gpUrl}
        method="POST"
        acceptCharset="UTF-8"
        name="peticionGp"
        onSubmit={this.handleRedsysRedirect}
      >
        {Object.entries(gpJson).map(([key, value]) => (
          <input type="hidden" name={key} value={String(value)} key={key} />
        ))}
        <input
          type="submit"
          value={qrType === 'test' ? t('TEST') : t('Pagar')}
          className="nm-btn-continue"
        />
      </form>
    );
  }

  initInsiteForm() {
    const { merchantCredentials, paymentId } = this.state;
    const { qrType } = this.props.location.state;
    if (!merchantCredentials || !paymentId) {
      console.warn('[Insite] initInsiteForm called but missing credentials or paymentId', { merchantCredentials, paymentId });
      return;
    }

    console.log('[Insite] initInsiteForm: setting up form', {
      paymentId,
      fuc: merchantCredentials.merchantCode,
      terminal: merchantCredentials.terminal,
      qrType,
      domain: window.location.hostname,
      origin: window.location.origin,
      sdkEnv: qrType === 'test' ? 'TEST (sis-t.redsys.es:25443)' : 'PRODUCTION (sis.redsys.es)',
    });

    if (qrType === 'test' && typeof window.REDSYS_DOMAIN !== 'undefined') {
      window.REDSYS_DOMAIN = 'https://sis-t.redsys.es:25443';
      console.log('[Insite] Overrode REDSYS_DOMAIN to test server');
    }

    const order = paymentId;

    // Redsys SDK only supports ONE active instance per page.
    // Use matchMedia to pick the container that is actually visible at the current viewport.
    const isDesktop = window.matchMedia('(min-width: 1200px)').matches;
    const containerId = isDesktop ? 'redsys-container-pc' : 'redsys-container-sm';

    if (!document.getElementById(containerId)) {
      this.setState({ insiteError: 'Error al inicializar el formulario de pago' });
      return;
    }

    console.log('[Insite] using container:', containerId);

    // Listen for viewport crossings so the form stays usable if the user resizes.
    if (!this._viewportMediaQuery) {
      this._viewportMediaQuery = window.matchMedia('(min-width: 1200px)');
      this._viewportChangeHandler = () => this._reinitInsiteForm();
      this._viewportMediaQuery.addEventListener('change', this._viewportChangeHandler);
    }

    // Official Redsys insite API: getInSiteForm + storeIdOper
    // storeIdOper handles the merchantValidation postMessage internally.
    this._insiteMessageHandler = (ev) => {
      if (!ev.origin.includes('redsys.es')) return;
      if (typeof window.storeIdOper === 'function') {
        window.storeIdOper(ev, 'redsys-token', 'redsys-error', () => true);
        const tokenEl = document.getElementById('redsys-token');
        const errorEl = document.getElementById('redsys-error');
        if (tokenEl && tokenEl.value) {
          const idOper = tokenEl.value;
          tokenEl.value = '';
          console.log('[Insite] idOper received:', idOper);
          this.setState({ insiteProcessing: true, insiteError: null });
          this.processInsitePayment(idOper);
        } else if (errorEl && errorEl.value) {
          const errCode = errorEl.value;
          errorEl.value = '';
          console.error('[Insite] error from SDK:', errCode);
          this.setState({ insiteError: `Error en la tarjeta (código: ${errCode})` });
        }
      }
    };
    window.addEventListener('message', this._insiteMessageHandler);

    try {
      // Official documented function: getInSiteForm(id, estiloBoton, estiloBody, estiloCaja, estiloInputs, buttonText, fuc, terminal, order, idioma, mostrarLogo)
      const insiteEstiloBoton = [
        'width: 100%',
        'padding: 14px 20px',
        'background: linear-gradient(45deg, #01315f, #067ddb)',
        'color: #ffffff',
        'border: none',
        'border-radius: 10px',
        'font-size: 16px',
        'font-weight: 600',
        'cursor: pointer',
        'margin-top: 16px',
        'box-shadow: 0 2px 8px rgba(1,49,95,0.25)',
        'letter-spacing: 0.3px',
      ].join('; ');

      const insiteEstiloBody = [
        'background: transparent',
        'margin: 0',
        'padding: 12px',
        'box-sizing: border-box',
        'font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
      ].join('; ');

      const insiteEstiloCaja = [
        'background: #ffffff',
        'border-radius: 12px',
        'border: 1px solid rgba(10,29,61,0.15)',
        'padding: 14px',
        'width: 100%',
        'box-sizing: border-box',
        'box-shadow: 0 2px 8px rgba(10,29,61,0.07)',
      ].join('; ');

      const insiteEstiloInputs = [
        'border: 1px solid #e2e8f0',
        'border-radius: 8px',
        'background: #f8fafc',
        'color: #1e293b',
        'font-size: 15px',
        'padding: 10px 12px',
        'width: 100%',
        'box-sizing: border-box',
      ].join('; ');

      window.getInSiteForm(
        containerId,
        insiteEstiloBoton,
        insiteEstiloBody,
        insiteEstiloCaja,
        insiteEstiloInputs,
        'Pagar',
        merchantCredentials.merchantCode,
        merchantCredentials.terminal,
        order,
        'ES',
        false
      );
      console.log(`[Insite] getInSiteForm called for #${containerId}`);
      this._activeContainerId = containerId;
      this.setState({ insiteFormInitialized: true });
    } catch (err) {
      console.error(`[Insite] getInSiteForm error for #${containerId}:`, err);
      window.removeEventListener('message', this._insiteMessageHandler);
      this.setState({ insiteError: 'Error al inicializar el formulario de pago' });
    }
  }

  // handleInsiteMessage is now inlined in initInsiteForm using storeIdOper (official API)

  // Called when the viewport crosses the 1200px breakpoint.
  // Clears the SDK content from the old container and re-initializes in the new one.
  _reinitInsiteForm() {
    if (this.state.insiteProcessing) return; // Don't interrupt a payment in progress
    if (this._activeContainerId) {
      const old = document.getElementById(this._activeContainerId);
      if (old) old.innerHTML = '';
      this._activeContainerId = null;
    }
    if (this._insiteMessageHandler) {
      window.removeEventListener('message', this._insiteMessageHandler);
      this._insiteMessageHandler = null;
    }
    // Keep _insiteInitStarted = true so componentDidUpdate doesn't race with the
    // direct initInsiteForm() call below. We own the re-init from the callback.
    this.setState({ insiteFormInitialized: false, insiteError: null }, () => {
      this.initInsiteForm();
    });
  }

  // ─── 3DS insite flow ─────────────────────────────────────────────────────────
  // Step 1: iniciaPeticion → get threeDSServerTransID + threeDSMethodURL
  // Step 2: 3DSMethod iframe (browser fingerprint, ~2s) → primer trataPeticion
  //         → frictionless (go to step 3) OR challenge (show ACS iframe, wait)
  // Step 3: segundo trataPeticion → final authorization
  // ─────────────────────────────────────────────────────────────────────────────

  _insiteCallParams(extra = {}) {
    const { paymentId, merchantCredentials } = this.state;
    const { lockerPrice, qrType } = this.props.location.state;
    return {
      idOper: this._idOper,
      price: lockerPrice,
      paymentId,
      secretKey: merchantCredentials.secretKey,
      merchantCode: merchantCredentials.merchantCode,
      currency: merchantCredentials.currency,
      terminal: merchantCredentials.terminal,
      isTest: qrType === 'test',
      ...extra,
    };
  }

  _insitePostStep(params) {
    return this.props.postRedsysInsite(params).then(a => {
      console.log('[3DS] step response:', JSON.stringify(a?.response));
      return a?.response;
    });
  }

  _insiteSuccess() {
    const { redsysURLOK } = this.state;
    const { lockerAssigned } = this.props.location.state;
    sessionStorage.setItem(`vacway_qr_payment_done_${lockerAssigned}`, '1');
    if (this.unblockHistory) this.unblockHistory();
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    window.location.href = redsysURLOK;
  }

  _insiteError(msg) {
    console.error('[3DS] error:', msg);
    this._cleanup3DS();
    this.setState({ insiteProcessing: false, insiteError: msg });
  }

  _cleanup3DS() {
    if (this._threeDSMethodIframe) {
      try { document.body.removeChild(this._threeDSMethodIframe); } catch (e) {}
      this._threeDSMethodIframe = null;
    }
    if (this._challengeIframe) {
      try { this._challengeIframe.parentNode.removeChild(this._challengeIframe); } catch (e) {}
      this._challengeIframe = null;
    }
    if (this._challengeMessageHandler) {
      window.removeEventListener('message', this._challengeMessageHandler);
      this._challengeMessageHandler = null;
    }
  }

  processInsitePayment(idOper) {
    this._idOper = idOper;
    this._paymentSubmitted = true;

    // ── Step 1: iniciaPeticion ────────────────────────────────────────────────
    this._insitePostStep(this._insiteCallParams({ step: 1 }))
      .then(res => {
        if (!res || res.error) {
          return this._insiteError(`Error en la inicialización 3DS (${res?.error || 'desconocido'})`);
        }
        const { protocolVersion, threeDSServerTransID, threeDSMethodURL } = res;
        console.log('[3DS] step 1 ok:', { protocolVersion, threeDSServerTransID, threeDSMethodURL });

        // ── 3DSMethod: load hidden iframe for browser fingerprinting ──────────
        const runStep2 = (completionInd) => {
          const browserInfo = {
            browserAcceptHeader: 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8',
            browserUserAgent: navigator.userAgent,
            browserJavaEnabled: false,
            browserJavascriptEnabled: true,
            browserLanguage: navigator.language || 'es-ES',
            browserColorDepth: String(screen.colorDepth || 24),
            browserScreenHeight: String(screen.height),
            browserScreenWidth: String(screen.width),
            browserTZ: String(-(new Date().getTimezoneOffset())),
          };

          // ── Step 2: primer trataPeticion ────────────────────────────────────
          this._insitePostStep(this._insiteCallParams({
            step: 2,
            protocolVersion,
            threeDSServerTransID,
            threeDSMethodCompletionInd: completionInd,
            notificationURL: 'https://lockers-qr-api.vacway.es/v1/qrs/redsys-3ds-notification',
            browserInfo,
          })).then(res2 => {
            if (!res2 || res2.error) {
              return this._insiteError(`Error en la autenticación 3DS (${res2?.error || 'desconocido'})`);
            }

            if (res2.directAuthorized) {
              // Redsys granted SCA exemption and directly authorized the payment
              console.log('[3DS] direct authorization (SCA exemption), payment complete');
              return this._insiteSuccess();
            } else if (res2.frictionless) {
              // Frictionless — no user challenge needed
              console.log('[3DS] frictionless, going to step 3');
              this._runStep3(res2.protocolVersion, res2.threeDSServerTransID, true, res2.eci, res2.authValue);
            } else if (res2.challengeRequired) {
              // Challenge — show ACS iframe and wait
              console.log('[3DS] challenge required, showing ACS iframe');
              this._showChallengeIframe(res2.acsURL, res2.creq, res2.protocolVersion, res2.threeDSServerTransID);
            } else {
              this._insiteError(`Respuesta 3DS inesperada (step 2)`);
            }
          }).catch(() => this._insiteError('Error al autenticar el pago'));
        };

        if (threeDSMethodURL) {
          // Load 3DSMethod in a hidden iframe to send browser fingerprint to ACS
          const iframe = document.createElement('iframe');
          iframe.style.cssText = 'display:none;width:0;height:0;position:absolute;';
          this._threeDSMethodIframe = iframe;
          document.body.appendChild(iframe);

          // The 3DSMethod form requires a POST with threeDSMethodData
          const methodData = btoa(JSON.stringify({
            threeDSServerTransID,
            threeDSMethodNotificationURL: 'https://lockers-qr-api.vacway.es/v1/qrs/redsys-3ds-notification',
          }));
          const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
          iframeDoc.open();
          iframeDoc.write(`<form id="f" method="POST" action="${threeDSMethodURL}">
            <input name="threeDSMethodData" value="${methodData}"/>
          </form><script>document.getElementById('f').submit();</script>`);
          iframeDoc.close();

          // Wait 2s for fingerprinting then proceed
          setTimeout(() => {
            try { document.body.removeChild(iframe); } catch (e) {}
            this._threeDSMethodIframe = null;
            runStep2('Y');
          }, 2000);
        } else {
          runStep2('U'); // No 3DSMethod URL — indicate it was not run
        }
      })
      .catch(() => this._insiteError('Error al inicializar el pago'));
  }

  _runStep3(protocolVersion, threeDSServerTransID, frictionless, eci, authValue) {
    this._insitePostStep(this._insiteCallParams({
      step: 3,
      protocolVersion,
      threeDSServerTransID,
      frictionless,
      eci,
      authValue,
    })).then(res => {
      if (res?.success) {
        this._insiteSuccess();
      } else {
        const errCode = res?.error || res?.Ds_Response || 'desconocido';
        this._insiteError(`Error en el pago (código: ${errCode})`);
      }
    }).catch(() => this._insiteError('Error al procesar el pago'));
  }

  _showChallengeIframe(acsURL, creq, protocolVersion, threeDSServerTransID) {
    // Render challenge iframe in the insite container area
    const container = document.getElementById(this._activeContainerId);
    if (!container) return this._insiteError('No se puede mostrar el desafío 3DS');

    const iframe = document.createElement('iframe');
    iframe.style.cssText = 'width:100%;min-height:400px;border:none;';
    this._challengeIframe = iframe;
    container.innerHTML = '';
    container.appendChild(iframe);

    // POST creq to acsURL inside the iframe
    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(`<form id="f" method="POST" action="${acsURL}">
      <input name="creq" value="${creq}"/>
    </form><script>document.getElementById('f').submit();</script>`);
    iframeDoc.close();

    // Listen for postMessage from the notification endpoint (challenge complete)
    this._challengeMessageHandler = (ev) => {
      if (!ev.origin.includes('lockers-qr') && !ev.origin.includes('vacway')) return;
      if (ev.data && ev.data.type === 'redsys3dsChallengeDone') {
        console.log('[3DS] challenge done, running step 3');
        window.removeEventListener('message', this._challengeMessageHandler);
        this._challengeMessageHandler = null;
        this._cleanup3DS();
        this._runStep3(protocolVersion, threeDSServerTransID, false);
      }
    };
    window.addEventListener('message', this._challengeMessageHandler);
  }

  insitePaymentForm(containerId) {
    const { redsys, insiteFormInitialized, insiteProcessing, insiteError } = this.state;

    if (!redsys) {
      return <div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>;
    }

    // Only render the container div for the one container the SDK was initialized with
    const defaultContainerId = window.matchMedia('(min-width: 1200px)').matches
      ? 'redsys-container-pc'
      : 'redsys-container-sm';
    const isActiveContainer = this._activeContainerId === containerId ||
      (!this._activeContainerId && containerId === defaultContainerId);

    return (
      <div className="redsys-insite-wrapper">
        {(!insiteFormInitialized || insiteProcessing) && isActiveContainer && (
          <div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>
        )}
        {/* Redsys SDK owns the DOM inside this div */}
        <div
          id={containerId}
          style={{
            display: (insiteFormInitialized && !insiteProcessing && isActiveContainer) ? 'block' : 'none',
          }}
        />
        {insiteError && isActiveContainer && (
          <div className="alert alert-danger mt-2" style={{ fontSize: '13px' }}>{insiteError}</div>
        )}
      </div>
    );
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  goTo(number, e) {
    history.push(`/phoneView`);
  }

  handleRedirect = () => {
    const { qr, lockerAssigned } = this.props.location.state;
    history.push(`/qrsale/${qr}?lockerAssigned=${lockerAssigned}`);
  };

  startCountdown = () => {
    const { timeStamp } = this.state;
    // Convert timeStamp (a Date object) into a millisecond timestamp.
    const startTime = new Date(timeStamp).getTime();
    const duration = 5 * 60 * 1000; // 5 minutes in ms
    const endTime = startTime + duration;

    this.countdownInterval = setInterval(() => {
      const now = Date.now();
      const diff = endTime - now;
      if (diff <= 0) {
        clearInterval(this.countdownInterval);
        this.setState({ minutes: 0, seconds: 0, isTimeUp: true });
        // Skip cancel if payment was already submitted (race condition guard)
        if (this._paymentSubmitted) return;
        // Free the pre-booked locker
        const { lockerAssigned, lockerMatricula, lockerMatrixId } = this.props.location.state;
        this.props.postCancelPrebooking({ LockerAssigned: lockerAssigned, LockerMatricula: lockerMatricula, LockerMatrixId: lockerMatrixId }).catch(console.error);
      } else {
        const minutes = Math.floor(diff / (60 * 1000));
        const seconds = Math.floor((diff % (60 * 1000)) / 1000);
        this.setState({ minutes, seconds });
      }
    }, 250);
  };

  TotalComponent() {
    const { iva } = this.state;
    const { lockerPrice } = this.props.location.state;

    let importeBase = (lockerPrice / (1 + iva / 100)).toFixed(2);
    let importeIva = (lockerPrice - importeBase).toFixed(2);
    let total = lockerPrice;

    this.setState({
      importeBase: importeBase,
      importeIva: importeIva,
      total: total,
    });

    return { total, importeBase, importeIva, iva };
  }

  getLockerPicture(type) {
    return `/images/measures/locker_final_${type}.png`;
  }

  getLockerType(type) {
    const { t, i18n } = this.props;

    switch (type) {
      case "BNS":
        return "Standard";
      case "CNS":
        return "Standard Carga";
      case "BWS":
        return "Standard XL";
      case "BNM":
        return "Medium";
      case "CNM":
        return "Medium Carga";
      case "BWM":
        return "Medium XL";
      case "CWM":
        return "Medium Carga XL";
      case "BNL":
        return "Large";
      case "CNL":
        return "Large Carga";
      case "BWL":
        return "Large XL";
      case "CWL":
        return "Large Carga XL";
      case "BNXL":
        return "Large";
      case "CNXL":
        return "Large Carga";
      case "BWXL":
        return "Large XL";
      case "CWXL":
        return "Large Carga XL";
      case "BN2XL":
        return "Large";
      case "CN2XL":
        return "Large Carga";
      case "BW2XL":
        return "Large XL";
      case "CW2XL":
        return "Large Carga XL";
      case "BN3XL":
        return "Ski";
      case "CN3XL":
        return "Ski Carga";
      case "BW3XL":
        return "Ski XL";
      case "BW3XL":
        return "Ski Carga XL";
      default:
        return "None";
    }
  }

  redsysForm(containerId = 'redsys-container-sm') {
    const { useRedsysInsite, paymentProvider } = this.props.location.state;
    if ((paymentProvider || 'redsys') === 'addon') {
      return this.gpPaymentForm(containerId);
    }
    if (useRedsysInsite) {
      return this.insitePaymentForm(containerId);
    }

    const {
      redsys,
      redsysSignature,
      redsysMerchant,
      redsysVersion,
      minutes,
      seconds,
    } = this.state;
    const {
      zoneSelected,
      descriptionZone,
      selectedAccessibility,
      selectedLocker,
      lockerPrice,
      lockerAssigned,
      lockerPin,
      lockerMatricula,
      lockerCustomer,
      lockerCustomerID,
      qr,
      qrType,
      qrMode,
      mail,
      phoneNumber,
      newsletterAcceptance,
      confirmReservation,
      idNumber,
    } = this.props.location.state;

    const { t, i18n } = this.props;

    const paymentId = Math.floor(Math.random() * 1000000 + 1).toString();
    const productionUrl = "https://sis.redsys.es/sis/realizarPago";

    let paymentDate = new Date().toISOString();

    const iappaURL = `https://lockers-qr.vacway.es/TicketView?zoneSelected=${zoneSelected}&descriptionZone=${descriptionZone}&selectedAccessibility=${selectedAccessibility}&selectedLocker=${selectedLocker}&lockerPrice=${lockerPrice}&lockerAssigned=${lockerAssigned}&lockerPin=${lockerPin}&lockerMatricula=${lockerMatricula}&lockerCustomer=${lockerCustomer}&customerId=${lockerCustomerID}&qrToken=${qr}&qrType=${qrType}&qrMode=${qrMode}&mail=${mail}&phoneNumber=${phoneNumber}&newsletterAcceptance=${newsletterAcceptance}&confirmReservation=${confirmReservation}&idNumber=${encodeURIComponent(idNumber || '')}&language=${
      i18n.language
    }&paymentId=${paymentId}&paymentDate=${encodeURIComponent(paymentDate)}`;

    const handleButtonClick = () => {
      if (this.unblockHistory) this.unblockHistory();
      window.removeEventListener('beforeunload', this.handleBeforeUnload);
      window.location.href = iappaURL;
    };

    if (!redsys || !redsysSignature || !redsysMerchant || !redsysVersion) {
      return (
        <div class="spinner">
          <img src="/images/logo.png" alt="Logo" />
        </div>
      );
    } else {
      if (qrType === "pay") {
        return (
          <html>
            <body>
              <form
                action="https://sis.redsys.es/sis/realizarPago"
                method="POST"
                accept-charset="UTF-8"
                name="peticionRedsys"
                onSubmit={this.handleRedsysRedirect}
              >
                <input
                  type="hidden"
                  name="Ds_SignatureVersion"
                  value={`${redsysVersion}`}
                />
                <input
                  type="hidden"
                  name="Ds_MerchantParameters"
                  value={`${redsysMerchant}`}
                />
                <input
                  type="hidden"
                  name="Ds_Signature"
                  value={`${redsysSignature}`}
                />
                <input
                  type="submit"
                  value={t("Pagar")}
                  className="nm-btn-continue"
                />
              </form>
            </body>
          </html>
        );
      } else if (qrType === "free") {
        return (
          <html>
            <body>
              <form method="POST" accept-charset="UTF-8" name="peticionRedsys">
                <input
                  type="hidden"
                  name="Ds_SignatureVersion"
                  value={`${redsysVersion}`}
                />
                <input
                  type="hidden"
                  name="Ds_MerchantParameters"
                  value={`${redsysMerchant}`}
                />
                <input
                  type="hidden"
                  name="Ds_Signature"
                  value={`${redsysSignature}`}
                />
                <input
                  type="button"
                  value={t("Reservar")}
                  className="nm-btn-continue"
                  onClick={handleButtonClick}
                />
              </form>
            </body>
          </html>
        );
      } else if (qrType === "test") {
        return (
          <html>
            <body>
              <form
                action="https://sis-t.redsys.es:25443/sis/realizarPago"
                method="POST"
                accept-charset="UTF-8"
                name="peticionRedsys"
                onSubmit={this.handleRedsysRedirect}
              >
                <input
                  type="hidden"
                  name="Ds_SignatureVersion"
                  value={`${redsysVersion}`}
                />
                <input
                  type="hidden"
                  name="Ds_MerchantParameters"
                  value={`${redsysMerchant}`}
                />
                <input
                  type="hidden"
                  name="Ds_Signature"
                  value={`${redsysSignature}`}
                />
                <input
                  type="submit"
                  value={t("TEST")}
                  className="nm-btn-continue"
                />
              </form>
            </body>
          </html>
        );
      } else {
        return (
          <html>
            <body>
              <form
                action="https://sis.redsys.es/sis/realizarPago"
                method="POST"
                accept-charset="UTF-8"
                name="peticionRedsys"
                onSubmit={this.handleRedsysRedirect}
              >
                <input
                  type="hidden"
                  name="Ds_SignatureVersion"
                  value={`${redsysVersion}`}
                />
                <input
                  type="hidden"
                  name="Ds_MerchantParameters"
                  value={`${redsysMerchant}`}
                />
                <input
                  type="hidden"
                  name="Ds_Signature"
                  value={`${redsysSignature}`}
                />
                <input
                  type="submit"
                  value={t("Pagar")}
                  className="nm-btn-continue"
                />
              </form>
            </body>
          </html>
        );
      }
    }
  }

  getTimerBadgeStyle() {
    const { qrData } = this.props;
    const buttonColor1 = qrData?.headerConfig?.buttonColor1 || null;
    const buttonColor2 = qrData?.headerConfig?.buttonColor2 || null;
    const buttonText = qrData?.headerConfig?.buttonText || null;
    if (!buttonColor1 && !buttonColor2 && !buttonText) return {};
    return {
      background: buttonColor1 ? `linear-gradient(135deg, ${buttonColor1}, ${buttonColor2 || buttonColor1})` : undefined,
      color: buttonText || undefined,
    };
  }

  getTimerStyle() {
    const { minutes } = this.state;
    if (minutes < 1) return { background: 'linear-gradient(135deg, #dc2626, #ef4444)' };
    if (minutes < 2) return { background: 'linear-gradient(135deg, #d97706, #f59e0b)' };
    return null;
  }

  render() {
    const { t } = this.props;
    const {
      redsys,
      iva,
      importeBase,
      importeIva,
      total,
      minutes,
      seconds,
      isTimeUp,
      discountApplied,
      startDate,
      endDate,
    } = this.state;
    const {
      descriptionZone,
      selectedLocker,
      qrMode,
      mail,
      phoneNumber,
    } = this.props.location.state;

    const urgent = minutes < 1;
    const warning = minutes < 2 && !urgent;

    if (!redsys && !this.state.gpError) {
      return (
        <div className="spinner">
          <img src="/images/logo.png" alt="Logo" />
        </div>
      );
    }

    const timerBanner = (
      <div
        className={`nm-phone-timer${urgent ? ' nm-phone-timer-urgent' : warning ? ' nm-phone-timer-warning' : ''}`}
        style={this.getTimerStyle()}
      >
        <div className="nm-phone-timer-left">
          <Timer size={22} strokeWidth={1.8} />
          <span className="nm-phone-timer-label">{t("Tiempo para confirmar")}</span>
        </div>
        <span className="nm-phone-timer-count">
          {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
        </span>
      </div>
    );

    const mainCard = (containerId) => (
      <>
        {timerBanner}
        <div className="nm-page-header-card">
          <div className="nm-page-header-card-text">
            <h3>{t("CONFIRMA TU COMPRA")}</h3>
            <span className="nm-page-header-zone">{t("Revisa los datos antes de confirmar el pago")}</span>
          </div>
          <CreditCard className="nm-form-icon" strokeWidth={1} />
        </div>

        <div className="nm-form nm-pay-card">
          <div className="nm-pay-card-inner">


            {/* ── Left: rental info ── */}
            <div className="nm-pay-card-left">

              {/* Locker thumbnail + name */}
              <div className="nm-pay-locker-row">
                <div className="nm-pay-locker-thumb">
                  <img
                    src={this.getLockerPicture(selectedLocker)}
                    alt={this.getLockerType(selectedLocker)}
                    className="nm-pay-locker-thumb-img"
                    onError={e => { e.target.style.display = 'none'; }}
                  />
                </div>
                <div className="nm-pay-locker-meta">
                  <span className="nm-pay-locker-name">{this.getLockerType(selectedLocker)}</span>
                  <span className="nm-pay-locker-zone">{descriptionZone}</span>
                </div>
              </div>

              <div className="nm-pay-divider" />

              {/* Dates */}
              <div className="nm-pay-fields">
                <div className="nm-pay-field">
                  <span className="nm-pay-field-label">{t("Inicio")}</span>
                  <span className="nm-pay-field-value">{startDate ? startDate.toLocaleDateString() : '—'}</span>
                </div>
                <div className="nm-pay-field">
                  <span className="nm-pay-field-label">{t("Fin")}</span>
                  <span className="nm-pay-field-value">{endDate ? endDate.toLocaleDateString() : '—'}</span>
                </div>
                <div className="nm-pay-field">
                  <span className="nm-pay-field-label">{t("Hora Límite")}</span>
                  <span className="nm-pay-field-value">
                    {qrMode === 0 ? t("HASTA FINALIZAR EL DÍA") : t("2 APERTURAS")}
                  </span>
                </div>
              </div>

              <div className="nm-pay-divider" />

              {/* Contact */}
              <div className="nm-pay-fields">
                <div className="nm-pay-field">
                  <span className="nm-pay-field-label">{t("Email")}</span>
                  <span className="nm-pay-field-value nm-pay-field-value-sm">{mail}</span>
                </div>
                <div className="nm-pay-field">
                  <span className="nm-pay-field-label">{t("Teléfono")}</span>
                  <span className="nm-pay-field-value">+{phoneNumber}</span>
                </div>
              </div>
            </div>

            {/* ── Column divider (desktop only) ── */}
            <div className="nm-pay-col-sep" />

            {/* ── Right: price + pay ── */}
            <div className="nm-pay-card-right">
              {discountApplied && (
                <div className="nm-pay-price-discount">
                  <span>{t("Te hemos aplicado un descuento en el precio, solo vas a pagar 5 días de tu reserva!")}</span>
                  <span className="nm-pay-discount-original">{total?.toFixed(2)}{currencySymbol()}</span>
                </div>
              )}

              <div className="nm-pay-price-section">
                <div className="nm-pay-price-row">
                  <span className="nm-pay-price-label">{t("Base")}</span>
                  <span className="nm-pay-price-value">{importeBase}{currencySymbol()}</span>
                </div>
                <div className="nm-pay-price-row">
                  <span className="nm-pay-price-label">{t("IVA")} ({iva}%)</span>
                  <span className="nm-pay-price-value">{importeIva}{currencySymbol()}</span>
                </div>
              </div>

              <div className="nm-pay-price-total-row">
                <span className="nm-pay-price-total-label">{t("Total")}</span>
                <span className="nm-pay-price-total-amount">{total}{currencySymbol()}</span>
              </div>

              <div className="nm-pay-form-wrap">{this.redsysForm(containerId)}</div>
            </div>

          </div>
        </div>

        {/* ── Actions card ── */}
        <div className="nm-pay-actions-card">
          <p className="nm-pay-actions-hint">{t("¿Necesitas hacer algún cambio?")}</p>
          <div className="nm-pay-actions-row">
            <button className="nm-pay-action-edit" onClick={() => this.setState({ showEditConfirm: true })}>
              <PenLine size={14} strokeWidth={2.2} />
              {t("Editar mis datos")}
            </button>
            <button className="nm-pay-action-cancel" onClick={() => this.setState({ showExitDialog: true, pendingNavigation: null })}>
              <X size={14} strokeWidth={2.2} />
              {t("Cancelar reserva")}
            </button>
          </div>
        </div>
      </>
    );

    return (
      <div className="normalBackground">
        {/* Hidden inputs for Redsys insite storeIdOper */}
        <input type="hidden" id="redsys-token" />
        <input type="hidden" id="redsys-error" />
        <AppHeader />

        <div className="nm-page smartphone">
          {mainCard('redsys-container-sm')}
          <NmStepBar step={4} />
        </div>

        <div className="nm-page pc">
          {mainCard('redsys-container-pc')}
          <NmStepBar step={4} />
        </div>

        {/* ── Time-up overlay ── */}
        {isTimeUp && (
          <div className="nm-exit-overlay">
            <div className="nm-exit-dialog">
              <div className="nm-exit-dialog-icon">⏰</div>
              <h4 className="nm-exit-dialog-title">{t('Tiempo de reserva agotado')}</h4>
              <p className="nm-exit-dialog-body">{t('Lo sentimos, pero no podemos reservar tu taquilla por más tiempo, otros usuarios deben poder acceder a ella. Vuelve a iniciar el proceso y finaliza la compra en el tiempo estipulado.')}</p>
              <div className="nm-exit-dialog-actions">
                <button className="nm-exit-btn-leave" onClick={this.handleRedirect}>
                  {t('Volver al inicio')}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ── Exit / cancel confirmation dialog ── */}
        {this.state.showExitDialog && (
          <div className="nm-exit-overlay">
            <div className="nm-exit-dialog">
              <div className="nm-exit-dialog-icon">⚠️</div>
              <h4 className="nm-exit-dialog-title">{t('¿Seguro que quieres salir?')}</h4>
              <p className="nm-exit-dialog-body">{t('Si abandonas ahora, tu taquilla reservada quedará libre y otro usuario podrá alquilarla.')}</p>
              <div className="nm-exit-dialog-actions">
                <button className="nm-exit-btn-stay" onClick={this.stayOnPage}>
                  {t('Continuar con el alquiler')}
                </button>
                <button className="nm-exit-btn-leave" onClick={this.cancelPrebookingAndLeave}>
                  {t('Cancelar y salir')}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ── Edit confirmation dialog ── */}
        {this.state.showEditConfirm && (
          <div className="nm-exit-overlay">
            <div className="nm-exit-dialog">
              <div className="nm-exit-dialog-icon">✏️</div>
              <h4 className="nm-exit-dialog-title">{t('¿Volver a editar tus datos?')}</h4>
              <p className="nm-exit-dialog-body">{t('Tu taquilla permanecerá reservada mientras completas el formulario.')}</p>
              <div className="nm-exit-dialog-actions">
                <button className="nm-exit-btn-stay" onClick={() => this.setState({ showEditConfirm: false })}>
                  {t('Quedarme aquí')}
                </button>
                <button className="nm-exit-btn-leave" onClick={this.goToPhoneView}>
                  {t('Editar mis datos')}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: true,
  redsys: state.redsys,
  qrData: state.qrs.qr,
});

const mapDispatchToProps = (dispatch) => ({
  push: bindActionCreators(push, dispatch),
  postRedsys: bindActionCreators(postRedsys, dispatch),
  postRedsysInsite: bindActionCreators(postRedsysInsite, dispatch),
  postGpPayment: bindActionCreators(postGpPayment, dispatch),
  postCancelPrebooking: bindActionCreators(postCancelPrebooking, dispatch),
  fetchCustomer: bindActionCreators(fetchCustomer, dispatch),
});

export default withNamespaces()(
  connect(mapStateToProps, mapDispatchToProps)(PaymentView)
);
